<template>
  <div>
    <v-card class="shadowCard mb-4 resultado-card" :style="{ borderTop: `4px solid ${resultado.nivel.color}` }">
      <v-card-title class="subtitle-1 font-weight-bold pb-1">
        Resultado
      </v-card-title>
      <v-card-text>
        <div class="text-center py-3">
          <div class="text-h3 font-weight-bold primary--text">
            {{ resultado.puntajeTotal }}
            <span class="text-h6 grey--text">/ {{ resultado.puntajeMaximo }}</span>
          </div>
          <div class="text-caption grey--text mb-2" v-if="resultado.criteriosSinDatos !== undefined">
            {{ resultado.criteriosActivos }} criterios cumplidos ·
            {{ resultado.criteriosSinDatos }} sin datos en sistema
          </div>
          <div class="text-caption grey--text mb-3" v-else>
            {{ resultado.criteriosActivos }} de {{ resultado.criteriosTotales }} criterios marcados
          </div>
          <v-progress-linear
            :value="resultado.porcentaje"
            height="10"
            rounded
            :color="resultado.nivel.chipColor"
            class="mb-3"
          ></v-progress-linear>
          <v-chip large :color="resultado.nivel.chipColor" dark class="px-6">
            {{ resultado.nivel.nombre }}
          </v-chip>
          <div class="text-body-2 mt-2 grey--text text--darken-1">
            {{ resultado.nivel.descripcion }}
          </div>
        </div>

        <v-divider class="my-3"></v-divider>

        <div class="subtitle-2 mb-2">Desglose por sección</div>
        <v-list dense class="py-0">
          <v-list-item
            v-for="seccion in resultado.desgloseSecciones"
            :key="seccion.id"
            class="px-0"
          >
            <v-list-item-content>
              <v-list-item-title class="text-body-2">{{ seccion.titulo }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action class="my-0">
              <strong>{{ seccion.puntosObtenidos }} / {{ seccion.maxPuntos }}</strong>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>

    <v-card class="shadowCard mb-4" v-if="mostrarCriterios">
      <v-card-title class="subtitle-2 py-3">Detalle de criterios inferidos</v-card-title>
      <v-card-text class="pt-0">
        <div v-for="seccion in resultado.desgloseSecciones" :key="seccion.id" class="mb-3">
          <div class="text-caption font-weight-bold mb-1">{{ seccion.titulo }}</div>
          <div
            v-for="criterio in seccion.criterios"
            :key="criterio.id"
            class="d-flex align-center py-1"
          >
            <v-icon small :color="colorEstado(criterio.estado)" class="mr-2">
              {{ iconoEstado(criterio.estado) }}
            </v-icon>
            <span class="text-body-2 flex-grow-1">{{ criterio.etiqueta }}</span>
            <v-chip x-small :color="colorEstado(criterio.estado)" dark class="ml-2">
              {{ etiquetaEstado(criterio.estado) }} · {{ criterio.puntosObtenidos }}/{{ criterio.puntos }}
            </v-chip>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-card class="shadowCard" v-if="!mostrarCriterios">
      <v-card-title class="subtitle-2 py-3">Niveles de calificación</v-card-title>
      <v-simple-table dense>
        <thead>
          <tr>
            <th>Nivel</th>
            <th class="text-center">Rango</th>
            <th>Acción sugerida</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="nivel in niveles"
            :key="nivel.id"
            :class="{ 'nivel-activo': resultado.nivel.id === nivel.id }"
          >
            <td>
              <v-chip x-small :color="nivel.chipColor" dark>{{ nivel.nombre }}</v-chip>
            </td>
            <td class="text-center">{{ etiquetaRango(nivel) }}</td>
            <td class="text-caption">{{ nivel.descripcion }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'PanelResultadoCalificacion',

  props: {
    resultado: { type: Object, required: true },
    niveles: { type: Array, required: true },
    mostrarCriterios: { type: Boolean, default: false },
  },

  methods: {
    colorEstado(estado) {
      if (estado === 'cumple') return 'green'
      if (estado === 'no_cumple') return 'red'
      return 'grey'
    },

    iconoEstado(estado) {
      if (estado === 'cumple') return 'mdi-check-circle'
      if (estado === 'no_cumple') return 'mdi-close-circle'
      return 'mdi-help-circle'
    },

    etiquetaEstado(estado) {
      if (estado === 'cumple') return 'Cumple'
      if (estado === 'no_cumple') return 'No cumple'
      return 'Sin datos'
    },

    etiquetaRango(nivel) {
      if (nivel.slug === 'alta') return '100+ pts'
      return nivel.min + ' – ' + nivel.max + ' pts'
    },
  },
}
</script>

<style scoped>
.resultado-card {
  position: sticky;
  top: 80px;
}

.nivel-activo {
  background-color: rgba(25, 118, 210, 0.08);
}

@media (max-width: 1263px) {
  .resultado-card {
    position: static;
  }
}
</style>
